var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransPending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1401_579",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10.5C8.2615 10.5 10.5 8.2615 10.5 5.5C10.5 2.7385 8.2615 0.5 5.5 0.5C2.7385 0.5 0.5 2.7385 0.5 5.5C0.5 8.2615 2.7385 10.5 5.5 10.5Z",
    fill: "white",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91419 4.08664L4.08569 6.91514M4.08569 4.08664L6.91419 6.91514",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1401_579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.5 -0.501434H11.5V11.4986H-0.5V-0.501434Z",
    fill: "#F98700"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransPending);
export default __webpack_public_path__ + "static/media/TransPending.2001b42aa5aec42f5c7f03daa41ba87e.svg";
export { ForwardRef as ReactComponent };